import React from 'react';
import { Switch } from '@headlessui/react';

/**
 * Restricts a tab's results to cards the user already owns. Each tab keeps its
 * own toggle, so recommendations and combos can be filtered independently.
 */
const OnlyCollectionToggle = ({ checked, onChange }) => (
  <div className="flex flex-row items-center gap-x-3">
    <Switch
      checked={checked}
      onChange={onChange}
      className={`${
        checked ? 'bg-accentDark' : 'bg-lightColor'
      } relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors`}>
      <span
        className={`${
          checked ? 'translate-x-6' : 'translate-x-1'
        } inline-block h-4 w-4 rounded-full bg-white transition-transform`}
      />
    </Switch>
    <span className="text-sm">Incluir solo cartas en colección</span>
  </div>
);

export default OnlyCollectionToggle;
